import Head from 'next/head';
// This component is only intended to be used in the pages/_app.js file
// DO NOT USE THIS COMPONENT ANYWHERE ELSE
// We need to use the old 'next/router' to set the canonical link
// eslint-disable-next-line no-restricted-imports
import { useRouter } from 'next/router';

import { buildWebsiteUrl } from '@repo/utils/url';

export default function CanonicalLink() {
  const router = useRouter();

  const canonicalUrl = buildWebsiteUrl(
    router.asPath.split('#')[0].split('?')[0]
  );

  // Note that the key is important, since that will enable de-duplication
  // Any canonical link added after this one that has key="canonical" will overwrite this, instead of having multiple per page
  return (
    <Head>
      <link key="canonical" href={canonicalUrl} rel="canonical" />
    </Head>
  );
}
